import gql from 'graphql-tag';

export const mutationDeleteTask = gql`
  mutation deleteTask (
    $id: DokkioID!
  ) {
    deleteTask (
      id: $id
    )
  }
`;
export default mutationDeleteTask;
